import React, { useState } from "react";
import * as yup from "yup";
import { TabView, TabPanel } from "primereact/tabview";
import Swal from "sweetalert2";
import JourneyTeam from "./journeyTeam";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import { saveSalesJourney } from "../../../../../services/crm/salesJourney";
import { Accordion, AccordionTab } from "primereact/accordion";
import JourneyHead from "./journeyHead";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import JourneyVisitForm from "./journeyVisit";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { DateTime } from "luxon";
const journeySchema = yup.object().shape({
  ID: yup.number(),
  title: yup
    .string()
    .required("Sales Journey Name is required")
    .max(255, "Sales Journey Name maximum characters is 255"),
  planStartDate: yup
    .date()
    .required("Plan Start Date is required")
    .max(
      yup.ref("planEndDate"),
      "Plan Start Date must be less equal to Plan End Date"
    ),
  planEndDate: yup
    .date()
    .required("Plan End Date is required")
    .min(
      yup.ref("planStartDate"),
      "Plan End Date must be greater equal to Plan Start Date"
    ),
  description: yup.string(),
  salesName: yup.string().required("Assigned To is required"),
  visits: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      journeyID: yup.number(),
      visitTo: yup.string().required("Visit To is Required"),
      customerID: yup.number(),
      leadID: yup.number(),
      salesCardID: yup.number(),
      salesCardTitle: yup.string(),
      planVisitDate: yup.date(),
    })
  ),
  teams: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      userID: yup.number(),
      userName: yup.string().required("Sales Name is required"),
      description: yup.string(),
    })
  ),
});
function JourneyForm({ match, history }) {
  const { journeyID } = match.params;
  const [activeIndex, setActiveIndex] = useState(0);
  const [journey, setJourney] = useState({
    ID: 0,
    title: "",
    planStartDate: DateTime.now().startOf("day"),
    planEndDate: DateTime.now().endOf("day"),
    salesID: 0,
    salesName: "",
    description: "",
    visits: [
      {
        ID: 0,
        journeyID: 0,
        visitType: 1,
        statusID: 1,
        visitTo: "",
        customerID: 0,
        leadID: 0,
        salesOrderID: 0,
        salesCardID: 0,
        salesCardTitle: "",
        planVisitDate: DateTime.now().endOf("day"),
        description: "",
        visitActivities: [],
      },
    ],
    teams: [
      {
        ID: 0,
        statusID: 1,
        userID: 0,
        userName: "",
        user: {
          userImage: [],
        },
      },
    ],
  });
  return (
    <React.Fragment>
      <AppForm
        initialValues={journey}
        validationSchema={journeySchema}
        onSubmit={async (values, { setStatus, setSubmitting }) => {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Sales Journey ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveSalesJourney(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  history.push("/crm/sales-journey");
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
        headSubmitButton={true}
      >
        <ContentLayout>
          <PageSubHeader
            title="Sales Journey Form"
            breadcrumbs={[
              { page: "/menu", title: "Menu", active: false },
              {
                page: "/crm/sales-journey",
                title: "Sales Journeys",
                active: false,
              },
              {
                page: "/crm/journey-form",
                title: "Sales Journey Form",
                active: true,
              },
            ]}
            actionButtons={[
              {
                title: "",
                color: "label-brand",
                icon: "fas fa-backward",
                onClick: () => {
                  history.push("sales-journey");
                },
              },
            ]}
          />
          <div className="tabview">
            <div className="card">
              <TabView className="tabview" scrollable>
                <TabPanel header="Sales Journeys" rightIcon="fas fa-route">
                  <JourneyHead />
                  <div className="accordion">
                    <div className="card">
                      <Accordion
                        className="accordion"
                        activeIndex={activeIndex}
                        onTabChange={(e) => setActiveIndex(e.index)}
                      >
                        <AccordionTab
                          header={
                            <React.Fragment>
                              <i className="fas fa-sitemap"></i>
                              <span>
                                <strong>Sales Journey Visit Items</strong>
                              </span>
                            </React.Fragment>
                          }
                        >
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <JourneyVisitForm arrayName="visits" />
                            </div>
                          </div>
                        </AccordionTab>
                      </Accordion>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel header="Teams" rightIcon="fas fa-user-friends">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <JourneyTeam />
                    </div>
                  </div>
                </TabPanel>
              </TabView>
            </div>
          </div>
        </ContentLayout>
      </AppForm>
    </React.Fragment>
  );
}

export default JourneyForm;
